
import React, { useState } from "react";
import {
  Alert,
  Button,
  Modal,
  PageHeader,
  PageTitle,
  TableAdv,
} from "../../../../../../components";
import { mapTableRows } from "../../../../../../utils";
import { employeePaymentDetailsrowData } from "../../../../../../assets/data/candidatesData";

const OtherpaymentUnapaidtimesheetModel = ({ open, onClose }) => {
  const EmployepaymentdetailsColumns = [
    { key: "JobTitle", label: "Job Title" },
    { key: "Client", label: "Client" },
    { key: "PayCycle", label: "Pay Cycle" },
    { key: "Classification", label: "Classification" },
    { key: "TotalHours", label: "Total Hours" },
    { key: "PayRate", label: "Pay Rate" },
    { key: "Total", label: "Total" },
  ];

  const mappedRows = mapTableRows(employeePaymentDetailsrowData, EmployepaymentdetailsColumns);

  return (
    <Modal isOpen={open} onClose={onClose} title="UNPAID TIMESHEET DETAILS" width="max-w-6xl">
      <div>
        <PageHeader
          Section={
            <div className="flex">
              <PageTitle title="Timesheets - opted to Pay as Other payment" tag="h6" />
            </div>
          }
        />
        <TableAdv
          tableId={`employee_payments_otherpayments_otherpaymentsunpaidtimesheetmodal2`}
          columns={EmployepaymentdetailsColumns}
          rows={[]} 
          hideToolBar
          showCheckbox={false}
        />
      </div>

      <div className="mt-4">
        <div className="border-b w-full">
          <PageHeader
            Section={
              <div className="flex">
                <PageTitle title="OTHER UNPAID TIMESHEETS" tag="h6" />
              </div>
            }
          />
        </div>

       
        <TableAdv
          tableId={`employee_payments_otherpayments_otherpaymentsunpaidtimesheetmodal3`}
          columns={EmployepaymentdetailsColumns}
          rows={mappedRows}
          hideToolBar
        />
      </div>
<div className="flex justify-end mt-4">
        <div className="bg-black text-white  flex gap-4 min-w-[400px] ">
          <div className="flex-1  justify-center text-center  border-white px-4 py-3">
            Total
          </div>
          <div className="w-px bg-white mx-2" />
          <div className="flex-1 px-4 py-3">$8600.00</div>
        </div>
      </div>
      <div className="flex gap-3 justify-end mt-3">
        <Button title="Cancel" variant="outlined" onClick={onClose} />
      </div>
    </Modal>
  );
};

export default OtherpaymentUnapaidtimesheetModel;
